import script from "./Signup.vue?vue&type=script&setup=true&lang=js"
export * from "./Signup.vue?vue&type=script&setup=true&lang=js"

import "./Signup.vue?vue&type=style&index=0&id=80e99a04&lang=scss"
import "./Signup.vue?vue&type=style&index=1&id=80e99a04&lang=scss"
import "./Signup.vue?vue&type=style&index=2&id=80e99a04&lang=scss&scoped=true"

import exportComponent from "/home/nicolas-choquet/www/play-private-store/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-80e99a04"]])

export default __exports__